import { Divider, Stack, Typography } from "@mui/material"
import { useTranslation } from "react-i18next";
import { CardEventBlue } from "./CardEventBlue"

export const EventList = ({ rows, myEvents, setReloadData }) => {
    const { t } = useTranslation('global');

    return (
        <>
            <Stack direction='row' justifyContent='space-between'>
                <Typography variant='h6' color='primary'>{t('tablestitles.events')}</Typography>
            </Stack>
            <Divider sx={{ margin: '10px 0', marginBottom:'20px' }} />

            <Stack direction='row' flexWrap='wrap' justifyContent='space-around' gap={2}>
                {
                    rows.map((event => <CardEventBlue key={event.id} event={event} myEvents={myEvents} setReloadData={setReloadData}/>))
                }
                
            </Stack>
        </>
    )
}
